import axios from "../shared/axios";

export const getSearchKeyword = async (query) => {
  return (
    await axios.get("/search/keyword", {
      params: {
        query,
      },
    })
  ).data.results
    .map((item) => item.name)
    .filter((_, index) => index < 5);
};

export const getSearchResult = async (typeSearch, query, page) => {
  const data = (
    await axios.get(`/search/${typeSearch}`, {
      params: {
        query,
        page,
      },
    })
  ).data;

  const results = data.results
    .map((item) => ({
      ...item,
      ...(typeSearch !== "multi" && { media_type: typeSearch }),
    }))
    .filter((item) => item.poster_path || item.profile_path);

  return {
    ...data,
    results,
  };
};
